import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PostalCode } from "../../domain/models/postal-code";
import { MasterlocationRepository } from "../../repositories/master-location.repository";

@Injectable({ providedIn: 'root' })
export class GetPostalCodesUsecase implements UseCase<null, PostalCode[]> {

  constructor(private readonly masterlocationRepository: MasterlocationRepository) {
  }

  execute(): Observable<PostalCode[]> {
    return this.masterlocationRepository.getPostalCodes();
  }

}
